<form [formGroup]="form">
  <mat-radio-group
    formControlName="input"
    [id]="outputInfoStore.state().output.id"
  >
    <div class="radio-button-row" *ngFor="let answerOption of answerOptions">
      <mat-radio-button [value]="answerOption.name">
        {{ answerOption.label }}
      </mat-radio-button>
      <h3-training-answer-icon
        *ngIf="(trainingAnswer$ | async) === answerOption.name"
      ></h3-training-answer-icon>
    </div>
  </mat-radio-group>
</form>
